export default "__VITE_ASSET__drwHbIuH__"